export default function PriorityChip({ option, isSelected, onClick }: any) {
  return (
    <button
      type="button"
      onClick={() => onClick(option)}
      className={`
        h-8 px-4 py-2 rounded-[12px] flex items-center gap-1.5
        text-[14px] leading-[1.35] tracking-[-0.56px] font-normal
        transition-all border
        ${
          isSelected
            ? "bg-[rgba(38,115,85,0.05)] border-[#46a580] border-[1.5px]"
            : "border-[#e6e8e7] bg-white"
        }
      `}
    >
      <div
        className="size-2 rounded-full shrink-0"
        style={{ backgroundColor: option.color }}
      />
      <span className="text-[#374741]">{option.label}</span>
    </button>
  );
}
